import React, { useState, useEffect } from "react";
import SubHead from "../SubHead";
import { Link, useNavigate, useParams } from "react-router-dom";

import { Get } from "../../../lib/Board";
import PopupPwdConfirm from "../../../component/PopupPwdConfirm";
import moment from "moment";

import { Viewer } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";

const Info = () => {
    const params = useParams();
    const navigate = useNavigate();

    const [showPasswordPopup, setShowPasswordPopup] = useState(false);
    const [password, setPassword] = useState("");
    const [board, setBoard] = useState(params.board);
    const [data, setData] = useState();

    useEffect(() => {
        Get(params.id, resultInfo);
    }, [params.id]);

    /**
     * 리스트
     */
    const resultInfo = response => {
        setData(response);
        if (response.password !== password) {
            setShowPasswordPopup(true);
        }
    };

    if (!data) {
        return <></>;
    }

    if (!data || data.password !== password) {
        return (
            <PopupPwdConfirm
                show={showPasswordPopup}
                onClose={e => {
                    setShowPasswordPopup(false);
                    navigate("/promotion/board_safety/list", { replace: true });
                }}
                onConfirm={pwd => {
                    if (data.password !== pwd) {
                        alert("비밀번호가 맞지 않습니다.");
                    } else {
                        setPassword(pwd);
                    }
                }}
            />
        );
    }

    return (
        <>
            <SubHead title="안전보건" eng="SAFETY"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <div className="board-detail-top">
                        <h2>{data.title}</h2>
                        <dl className="info">
                            <dt>날짜</dt>
                            <dd>{moment(data.createdAt).format("YYYY. MM. DD")}</dd>
                            <dt>작성자</dt>
                            <dd>{data.name}</dd>
                            <dt>조회</dt>
                            <dd>{data.show}회</dd>
                            {/* <dt>댓글</dt>
                            <dd>0건</dd> */}
                        </dl>
                    </div>
                    {data.uploadFiles && data.uploadFiles.length > 0 && (
                        <div className="board-detail-attachment">
                            <ul>
                                {data.uploadFiles.map(x => (
                                    <li>
                                        <a href={x.url} className="sbj">
                                            {x.originalname} ({x.size})
                                        </a>
                                        <p className="infos">Date : {moment(x.createdAt).format("YYYY-MM-DD HH:mm:ss")}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="board-detail-contents">
                        {/* <p dangerouslySetInnerHTML={{ __html: data.contents }}></p> */}
                        <Viewer initialValue={data.contents || ""} />;
                    </div>
                    <div className="board-detail-next">
                        {data.prev ? (
                            <Link to={`/promotion/board_safety/info/${data.prev.board}/${data.prev.id}`} className="prev">
                                <span className="cate">이전글</span>
                                <span className="sbj">{data.prev.title}</span>
                            </Link>
                        ) : (
                            <a href="#" className="prev">
                                <span className="cate"></span>
                                <span className="sbj"></span>
                            </a>
                        )}
                        {data.next ? (
                            <Link to={`/promotion/board_safety/info/${data.next.board}/${data.next.id}`} className="next">
                                <span className="cate">다음글</span>
                                <span className="sbj">{data.next.title}</span>
                            </Link>
                        ) : (
                            <a href="#" className="next">
                                <span className="cate"></span>
                                <span className="sbj"></span>
                            </a>
                        )}
                    </div>
                    <div className="board-detail-btns">
                        <button
                            type="button"
                            className="btn_nor lg red-line"
                            onClick={e => {
                                navigate("/promotion/board_safety/list", { replace: true });
                            }}
                        >
                            목록
                        </button>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Info;
